import styled from "styled-components";

export const CircleContainer = styled.div`
  position: relative;
  width: 72px;
  height: 72px;
  min-width: 72px;
  min-height: 72px;
  flex-basis: 72px;
`;

export const CircleIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
